export default {
  'password': 'กรุณากรอกรหัสผ่าน',
  'passwordError': 'รหัสผ่าน 8-20 หลักรองรับเฉพาะตัวพิมพ์ใหญ่ตัวเลขและสัญลักษณ์รวมกัน 3 ชนิดขึ้นไป',
  'passwordAgain': 'กรุณากรอกรหัสผ่านอีกครั้ง',
  'passwordNotSame': 'รหัสผ่านไม่ตรงกัน โปรดกรอกอีกครั้ง',
  'requiredVerifyCode': 'โปรดกรอกรหัสการยืนยัน',
  'verifyCode': 'ข้อผิดพลาดของรหัสยืนยัน'
}
